module.exports = __webpack_public_path__ + "img/popular-posts-2.fc6cf7f9.png";